import React from 'react';
import { useLocalization } from '../../../../utils/useLocalization';
import { useNavigate } from 'react-router-dom';
import './styles.scss';

const PasswordSuccess: React.FC = () => {
    const { passwordReset } = useLocalization();
    const navigation = useNavigate();

    function backHandler() {
        navigation('/login');
    }
    return (
        <div className={'password_success_container'}>
            <div className={'header u-mt-xlarge'}>
                <h4>{passwordReset.TITLE}</h4>
                <p className={'description u-mt'}>
                    {passwordReset.SUCCESS_INFO}
                </p>
            </div>
            <div className='o-button-container'>
                <button
                    className={'c-btn c-btn--full'}
                    type={'button'}
                    onClick={backHandler}
                >
                    <span className='c-btn__text'>
                        {passwordReset.LABEL_BACK_BUTTON}
                    </span>
                </button>
            </div>
        </div>
    );
};

export default PasswordSuccess;
